// debounce.js 内容
export default function delay(fn, time = 200) {
  let timer = null
  return function (...args) {
    const context = this // 保存上下文
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      fn.apply(context, args) // 使用保存的上下文和参数
    }, time)
  }
}
